module.exports = __webpack_public_path__ + "static/media/6.847b1870.png";